const clearCacheData = (): void => {
  caches.keys().then((names: string[]) => {
    names.forEach(name => {
      caches.delete(name)
    })
  })
}

export { clearCacheData }
